export const validateReferralCodeFormat = (code: string): boolean => {
	const referralCodeRegex = /^R\d{3}-\d{4}-\d{4}$/;
	return referralCodeRegex.test(code);
};
